export enum PurchaseStatusOptions {
  OPEN = 'open',
  PURCHASED = 'purchased',
  CANCELLED = 'cancelled'
}

export enum BtnTextStatus {
  PURCHASED = 'purchased',
  CANCELLED = 'cancelled'
}
